const COMMENTS_API_ROOT = '/restapi/public/v1/';

const baseApi = {};

export {
    baseApi,
    COMMENTS_API_ROOT
};
